/**
 * @generated SignedSource<<716b8ebcbde491b59b31e2c4eba8a4a3>>
 * @relayHash efb61ffbceedd384139bac603a332ca5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 746679e02f2d43ad1d6a3c7a0bcc8232b2c1e257737124123e8a9beb06e6d762

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type multiSelectWithRelayEditViewFieldOptionsPrefetchQuery$variables = {
  first?: number | null | undefined;
  id: string;
  isSelectableField: boolean;
};
export type multiSelectWithRelayEditViewFieldOptionsPrefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"multiSelect_issueFieldMultiSelectEditviewFull_MultiSelectEditViewWithFieldOptionsFragment" | "ui_issueSelectableFieldEditView_SelectableFieldEditViewWithFieldOptionsFragment">;
};
export type multiSelectWithRelayEditViewFieldOptionsPrefetchQuery = {
  response: multiSelectWithRelayEditViewFieldOptionsPrefetchQuery$data;
  variables: multiSelectWithRelayEditViewFieldOptionsPrefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSelectableField"
},
v3 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v4 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "id"
},
v5 = {
  "kind": "Literal",
  "name": "searchBy",
  "value": ""
},
v6 = [
  (v3/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/)
],
v7 = [
  (v4/*: any*/)
],
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = [
  (v3/*: any*/),
  (v5/*: any*/)
],
v10 = {
  "kind": "ScalarField",
  "name": "optionId"
},
v11 = {
  "kind": "ScalarField",
  "name": "isDisabled"
},
v12 = {
  "kind": "ScalarField",
  "name": "id"
},
v13 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v14 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v15 = [
  "searchBy",
  "filterById"
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "multiSelectWithRelayEditViewFieldOptionsPrefetchQuery",
    "selections": [
      {
        "condition": "isSelectableField",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v6/*: any*/),
            "kind": "FragmentSpread",
            "name": "multiSelect_issueFieldMultiSelectEditviewFull_MultiSelectEditViewWithFieldOptionsFragment"
          }
        ]
      },
      {
        "condition": "isSelectableField",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v6/*: any*/),
            "kind": "FragmentSpread",
            "name": "ui_issueSelectableFieldEditView_SelectableFieldEditViewWithFieldOptionsFragment"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "multiSelectWithRelayEditViewFieldOptionsPrefetchQuery",
    "selections": [
      {
        "condition": "isSelectableField",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v7/*: any*/),
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": (v9/*: any*/),
                    "concreteType": "JiraOptionConnection",
                    "kind": "LinkedField",
                    "name": "fieldOptions",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": "value",
                                "kind": "ScalarField",
                                "name": "id"
                              },
                              {
                                "alias": "label",
                                "kind": "ScalarField",
                                "name": "value"
                              },
                              (v10/*: any*/),
                              (v11/*: any*/),
                              (v12/*: any*/),
                              (v8/*: any*/)
                            ]
                          },
                          (v13/*: any*/)
                        ]
                      },
                      (v14/*: any*/)
                    ]
                  },
                  {
                    "args": (v9/*: any*/),
                    "filters": (v15/*: any*/),
                    "handle": "connection",
                    "key": "multiSelect_issueFieldMultiSelectEditviewFull_fieldOptions",
                    "kind": "LinkedHandle",
                    "name": "fieldOptions"
                  }
                ],
                "type": "JiraMultipleSelectField"
              },
              (v12/*: any*/)
            ]
          }
        ]
      },
      {
        "condition": "isSelectableField",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v7/*: any*/),
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "type"
                  }
                ],
                "type": "JiraIssueField",
                "abstractKey": "__isJiraIssueField"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": (v9/*: any*/),
                    "concreteType": "JiraSelectableValueConnection",
                    "kind": "LinkedField",
                    "name": "selectableValueOptions",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraSelectableValueEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v12/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "selectableLabel"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "selectableGroupKey"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "selectableIconUrl"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v11/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "type": "JiraOption"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "versionId"
                                  }
                                ],
                                "type": "JiraVersion"
                              }
                            ]
                          },
                          (v13/*: any*/)
                        ]
                      },
                      (v14/*: any*/)
                    ]
                  },
                  {
                    "args": (v9/*: any*/),
                    "filters": (v15/*: any*/),
                    "handle": "connection",
                    "key": "selectableValue_issueFieldEditviewFull_fieldOptions__selectableValueOptions",
                    "kind": "LinkedHandle",
                    "name": "selectableValueOptions"
                  }
                ],
                "type": "JiraHasSelectableValueOptions",
                "abstractKey": "__isJiraHasSelectableValueOptions"
              },
              (v12/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "746679e02f2d43ad1d6a3c7a0bcc8232b2c1e257737124123e8a9beb06e6d762",
    "metadata": {},
    "name": "multiSelectWithRelayEditViewFieldOptionsPrefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "b1aa220871b9e277aa6c9ec97f255935";

export default node;
